<!-- @format -->

<template>
  <div class="custom-modal" id="sub-event-records">
    <div class="modal-body">
      <transition name="el-fade-in" mode="out-in">
        <HolaconLottie v-if="loading == 'updateScreenLoading'" key="create-loading" />
        <el-row v-else>
          <el-row v-if="list.length > 0">
            <el-col :span="24" class="mb-2">
              <el-button type="primary" :icon="loading == 'listLoading' ? 'fas fa-spinner fa-spin' : 'fas fa-search'" size="mini" @click="isFilterEnabled = !isFilterEnabled" round>{{ $t("components.subEventRecords.filter") }}</el-button>
            </el-col>
            <transition name="el-zoom-in-top" mode="out-in">
              <el-col :span="24" v-if="isFilterEnabled">
                <div class="mb-2 automated-message-filter">
                  <div class="filter-body">
                    <el-row :gutter="16" class="mt-2">
                      <el-col :span="24">
                        <div class="registerform-input-container">
                          <div class="custom-label">
                            <label>{{ this.$t("event.filter.search") }}</label>
                          </div>
                          <el-input v-model="filter.searchTerm" placeholder="..."></el-input>
                        </div>
                      </el-col>
                      <el-col :span="12" class="mt-2">
                        <div class="registerform-input-container">
                          <div class="custom-label">
                            <label>{{ $t("components.subEventRecords.subEvents") }}</label>
                          </div>
                          <el-select v-model="filter.subEventIds" multiple @clear="filter.subEventIds = []" clearable :placeholder="$t('components.subEventRecords.placeholderAll')">
                            <el-option v-for="option in $store.state.subevents.items" :key="option.id" :label="option.title" :value="option.id"></el-option>
                          </el-select>
                        </div>
                      </el-col>
                      <el-col :span="12" class="mt-2">
                        <div class="registerform-input-container">
                          <div class="custom-label">
                            <label>{{ $t("components.subEventRecords.status") }}</label>
                          </div>
                          <el-select v-model="filter.subEventRegistrationStatus" @clear="filter.subEventRegistrationStatus = null" clearable :placeholder="$t('components.subEventRecords.placeholderAll')">
                            <el-option v-for="item in getEnums.find(x => x.title == 'SubEventRegistrationStatus').enums" :label="item.displayName" :key="item.key" :value="item.key"></el-option>
                          </el-select>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                  <div class="filter-footer d-flex justify-content-between mt-2">
                    <div class="left-buttons">
                      <el-button size="mini" @click="isFilterEnabled = !isFilterEnabled">{{ $t("onsiteUtilities.promotions.close") }}</el-button>
                    </div>
                    <div class="right-buttons">
                      <el-button size="mini" @click="filterReset" type="primary">{{ $t("onsiteUtilities.promotions.reset") }}</el-button>
                    </div>
                  </div>
                </div>
              </el-col>
            </transition>
          </el-row>
          <div class="promotion-box-container" v-if="list.length > 0">
            <div class="subevent-history-header custom-grid-table-header">
              <span>{{ $t("components.subEventRecords.participant") }}</span>
              <span>{{ $t("components.subEventRecords.subEventRecords") }}</span>
            </div>
            <div class="subevent-history-list">
              <div class="item" v-for="item in list" :key="item.id">
                <span class="d-flex align-items-center justify-content-center participant-item"><ParticipantMini :type="1" :data="prepareParticipantMini(item)"/></span>
                <div class="subevent-area">
                  <div class="subevent-item" v-for="subevent in item.subEventRegistrations" :key="subevent.id">
                    <div class="subevent-title" v-if="$store.state.subevents.items.some(x => x.id == subevent.subEventID)">
                      {{ $store.state.subevents.items.find(x => x.id == subevent.subEventID).title }}
                    </div>
                    <div class="subevent-status ">
                      <el-dropdown placement="bottom-start">
                        <span class="status payment-awaiting" :class="{ 'payment-awaiting': subevent.status == 0, rejected: subevent.status == 2, confirmed: subevent.status == 1 }">
                          <template v-if="subevent.status == 0">
                            <i class="fas fa-clock"></i>
                            {{ $t("summaryComponent.waiting-for-approval") }}
                          </template>

                          <template v-if="subevent.status == 1">
                            <i class="fas fa-check-circle"></i>
                            {{ $t("summaryComponent.approved") }}
                          </template>
                          <template v-if="subevent.status == 2">
                            <i class="fas fa-times-circle"></i>
                            {{ $t("summaryComponent.denied") }}
                          </template>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item class="status-pending-approve" v-if="subevent.status != 1" @click.native="approveSubEvent(subevent.id)">
                            <i class="fas fa-check"></i>
                            {{ $t("components.subEventRecords.confirm") }}
                          </el-dropdown-item>
                          <el-dropdown-item class="status-pending-reject" v-if="subevent.status != 2" @click.native="cancelSubEvent(subevent.id)">
                            <i class="fas fa-times-circle"></i>
                            {{ $t("components.subEventRecords.reject") }}
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <HolaconLottieNoData class="w-100" key="create-loading" :source="'holacon-event-lottie'" :title="$t('registrationManagement.subeventRegistrations.subeventRegistration')" @btnAdd="false" @btnRefresh="false" :buttonAdd="false" :buttonRefresh="false" :loading="loading" />
          </div>
        </el-row>
      </transition>
    </div>
    <div class="modal-footer" slot="footer" v-if="loading != 'updateScreenLoading'">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{ $t("event.buttons.close") }}</el-button>
      </div>
      <div class="center-buttons"></div>
      <div class="right-buttons">
        <el-pagination v-if="list.length > 0" small background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="filter.page" :page-sizes="[20, 30, 40, 50]" :page-size="filter.take" layout="total,sizes,prev, pager, next" :total="filter.total"></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import ParticipantMini from "./ParticipantMini.vue";
export default {
  components: {
    ParticipantMini
  },
  data() {
    return {
      loading: false,
      timeout: null,
      isFilterEnabled: false
    };
  },
  async created() {
    this.loading = "updateScreenLoading";
    if (this.timeout != null) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      await this.$store.dispatch("getSubEventRecords");
      this.loading = false;
    }, 500);
  },
  computed: {
    getEnums() {
      return this.$store.getters.getEnums;
    },
    filter() {
      return this.$store.getters.getSubEventRecordFilter;
    },
    list() {
      return this.$store.getters.getSubEventRecordList;
    }
  },
  methods: {
    async approveSubEvent(id) {
      this.loading = "approveSubEvent-" + id;
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("participantConfirmSubEvent", id);
        if (!res.data.alert.hasError) {
          await this.$store.dispatch("getSubEventRecords");
        }
        this.loading = false;
      }, 500);
    },
    async cancelSubEvent(id) {
      this.loading = "approveSubEvent-" + id;
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("participantCancelSubEvent", id);
        if (!res.data.alert.hasError) {
          await this.$store.dispatch("getSubEventRecords");
        }
        this.loading = false;
      }, 500);
    },
    prepareParticipantMini(row) {
      return {
        firstName: row.firstName,
        lastName: row.lastName,
        participantNO: row.participantNO,
        tagID: row.tagID,
        id: row.id
      };
    },

    filterReset() {
      this.$store.commit("subEventResetFilter");
    },
    handleSizeChange(take) {
      this.filter.take = take;
      // this.$store.commit('setSubEventRecordTake', take)
    },
    handleCurrentChange(page) {
      this.filter.page = page;
      $("html, body").animate({ scrollTop: 0 }, 350);
    },
    openExcellDialog() {}
  },
  watch: {
    filter: {
      deep: true,
      async handler() {
        this.loading = "listLoading";
        if (this.timeout != null) clearTimeout(this.timeout);
        this.timeout = setTimeout(async () => {
          await this.$store.dispatch("getSubEventRecords");
          this.loading = false;
        }, 500);
      }
    }
  }
};
</script>

<style lang="less">
#sub-event-records {
  .subevent-history-header {
    grid-template-columns: 180px 1fr;
  }
  .subevent-history-list {
    .item {
      gap: 0.5rem;
      display: grid;
      grid-template-columns: 180px 1fr;
      border-radius: 8px;
      background-color: #f1f1f1;
      margin-bottom: 10px;
      &:last-child {
        margin-bottom: 0;
      }

      .participant-item {
        padding: 10px;
        .participant-card-mini.mini {
          align-items: center;
        }
      }

      .subevent-area {
        display: flex;
        flex-direction: column;
        justify-content: center;
        border-left: 2px solid #fff;
        .subevent-item {
          display: grid;
          grid-template-columns: 1fr 150px;
          align-items: center;
          padding: 20px;
          border-bottom: 2px solid #fff;
          .subevent-title {
            font-size: 14px;
            font-weight: bold;
          }
          &:last-child {
            border-bottom: unset;
          }
        }
      }
    }
  }
}
</style>
<style scoped lang="less">
.subevent-status {
  .el-dropdown {
    & > .status {
      display: block;
      width: fit-content;
      padding: 0px 10px;
      border-radius: 8px;
      color: #292f3b;
      font-weight: 500;
      i {
        margin-right: 8px;
      }
      &.pending {
        background: #f1f1f1;
        cursor: pointer;
        i {
          color: #292f3b;
        }
      }
      &.payment-awaiting {
        background: #fff2e5;
        cursor: pointer;
        i {
          color: #f98559;
        }
      }
      &.confirmed {
        background: #e5fff8;
        i {
          color: #50bfbf;
        }
      }
      &.rejected {
        background: #fff2f2;
        i {
          color: #ff6565;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SubEventRecords.vue